import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import ViewPage from '../../../Components/ViewPage';

import {
  ROUTE_DESIGN_INSIGHTS,
  ROUTE_DESIGN_INSIGHTS_ACCURACY_SUBMISSION,
} from '../../../Routes/routes';

const BREADCRUMBS = [{
  title: 'Design Insights',
  route: `/${ROUTE_DESIGN_INSIGHTS}`,
}, {
  title: 'Accuracy Submission',
  route: `/${ROUTE_DESIGN_INSIGHTS_ACCURACY_SUBMISSION}`,
}];

function Submission({
  toggleDrawer,
}) {
  return (
    <ViewPage title="Submission" toggleDrawer={toggleDrawer} breadcrumbs={BREADCRUMBS}>
      <Box data-testid="Submission-View-Container">
        <h1>Submission</h1>
      </Box>
    </ViewPage>
  );
}

Submission.propTypes = {
  toggleDrawer: PropTypes.func,
};

Submission.defaultProps = {
  toggleDrawer: () => {
    // Default
  },
};

export default Submission;
